import { ReactComponent as Icon } from "../files/close-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const CloseIcon = ({ fill, style }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default CloseIcon;
